import React, { useRef } from 'react';

import { SelectOption } from '../select/select.interface';

export interface Chip {
  id?: string;
  label: string;
  value: string;
  className?: string;
  chipOnClick?: (selectedOption: SelectOption) => void;
}

const Chip = ({ id = '', label, value, className, chipOnClick }: Chip) => {
  const chipRef = useRef<HTMLSpanElement>(null);

  const handleClick = (selectedOption: SelectOption) => {
    if (chipRef.current) {
      // Toggle border
      if (chipRef.current.classList.contains('border-black-500')) {
        chipRef.current.classList.remove('border-2', 'border-black-500');
        if (chipOnClick) {
          chipOnClick({ optionText: '', optionValue: '' });
        }
      } else {
        if (chipOnClick) {
          chipOnClick(selectedOption);
        }
      }
    }
  };

  return (
    <>
      <span
        className={`${className} cursor-pointer rounded-lg bg-brand-white px-3 py-2 font-title text-buttonlabelxs text-neutral-grey-700`}
        ref={chipRef}
        onClick={() =>
          handleClick && handleClick({ optionText: label, optionValue: value })
        }
      >
        {label}
      </span>
    </>
  );
};

export default Chip;
